
import { defineComponent } from "vue";
import Folder from "@/components/shared/Folder.vue"; // @ is an alias to /src
import TitlebarButtons from "@/components/shared/TitlebarButtons.vue"; // @ is an alias to /src

export default defineComponent({
  name: "Menu",
  components: {
    TitlebarButtons,
    Folder
  },
  emits: ["update-focus"],
  methods: {
    updateFocus(focusValue: string, exitMenu?: boolean) {
      if (exitMenu) {
        this.$emit("update-focus", focusValue);
      } else if (focusValue === "") {
        this.$emit("update-focus", "");
      }
    }
  }
});
